import { render, staticRenderFns } from "./FaultCard.vue?vue&type=template&id=1afd0736&"
import script from "./FaultCard.vue?vue&type=script&lang=ts&"
export * from "./FaultCard.vue?vue&type=script&lang=ts&"
import style0 from "./FaultCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSheet,VTooltip})
